export default {
  name: 'marking--ismpDocumentType',
};